<template>
  <v-app
    class="marketplace__wrapper"
    :style="isMobile ? 'padding-bottom: 75px' : '' "
  >
    <pages-core-app-bar />
    <core-drawer />
    <pages-core-view />
    <pages-core-footer v-if="!isMobile" />
    <bottom-nav v-if="isMobile" />
  </v-app>
</template>

<script>
  export default {
    name: 'PagesIndex',

    components: {
      PagesCoreAppBar: () => import('./components/core/AppBar'),
      PagesCoreFooter: () => import('./components/core/Footer'),
      BottomNav: () => import('./components/core/BottomNav'),
      CoreDrawer: () => import('./components/core/Drawer'),
      PagesCoreView: () => import('./components/core/View'),
    },
    computed: {
      user () {
        return this.$store.state.users.user
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },

    created () {
      this.$vuetify.theme.dark = false
    },
    // beforeDestroy () {
    //   this.$vuetify.theme.dark = true
    // },
  }
</script>
<style lang="scss">
  .marketplace__wrapper{
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
